// src/utils/publicAxios.js
import axios from 'axios';

const publicAxios = axios.create({
   baseURL: process.env.REACT_APP_API_URL,
});


export default publicAxios;